<div class="modal full fade" id="modalJasper" tabindex="-1" role="dialog" aria-labelledby="TituloModalCentralizado"
  aria-hidden="true" data-backdrop="static" data-keyboard="false" style="padding-left: 0px !important;">
  <div class="modal-dialog modal-xl" role="document" style="max-width: 90%;  width: 100%; max-height: 80%;
    height: 100%; padding: 0;">
    <div class="modal-content" style="height: auto; min-height: 100%; border-radius: 10px;">
      <div class="modal-header justify-content-between" style="height: 50px;">
        <img class='bt-fechar ms-auto' style="fill: white; width: 1,25rem; margin: 5px;"
          src='assets/img/icon_bt-limpar_header.svg' data-bs-dismiss="modal" id="voltaTelaInicial">
      </div>
      <div class="modal-body">
        <div id='loading-relatorios-jasper' class="open" [hidden]="!controlStatus.carregandoRelatoriosJasper">
          <img class='img-loading' *ngIf="!this.controlStatus.erroRelatorio" src='assets/img/loading-preto.gif'>
          <span> {{this.controlStatus.avisoRelatorio}} </span>
          <button class='bt-fechar' *ngIf="this.controlStatus.erroRelatorio" (click)="fecharLoading()">
            <img class='ms-1' src='assets/img/bt_fechar_streetView.png' alt="">
            Fechar
          </button>
        </div>
        <iframe
          (load)="this.controlStatus.carregandoRelatoriosJasper = false && this.controlStatus.carregandoRelatorios = false"
          id="fr" name="myFrame" height="100%" width="100%" style="height: 90vh;" ></iframe>
      </div>
    </div>
  </div>
</div>
